<template>
    <rkm-modal
        large
        ref="RkmModal"
        :title="titulo"
    >
        <rkm-alert show info>
            A cota do APP Cidadão funciona como limite do canal cidadão e não como reserva exclusiva de uso do aplicativo.
        </rkm-alert>

        <rkm-table
            :items="linhas"
            :fields="fields"
            class="mt-3"
        >
            <template v-slot:cell(limiteApp)="{ item }">
                {{ item.limiteApp }}
            </template>
        </rkm-table>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">Fechar</rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import tipoCota from '@/enums/exame-imagem/tipoCota'

export default {
    computed: {
        titulo() {

            if (!this.item) return 'Detalhe da cota APP Cidadão'

            return `App ConectaSUS - Cidadão  ${this.item.nomeFantasia} / ${this.item.infraestruturaNome}`
        },
        linhas() {

            if (!this.item) return []

            const cotaPrestador = this.cotas.find(c => c.infraestruturaId === this.item.infraestruturaId)

            if (!cotaPrestador) return []

            const entry = (this.prestadores || []).find(p => p.infraestruturaId === this.item.infraestruturaId)

            const percentual = this.item.cotaTipoId === this.enums.tipoCota.VALOR
                ? (entry?.percentualFinanceiro ?? null)
                : (entry?.percentualQuantitativo ?? null)

            const cotasDoTipo = cotaPrestador.cotaSolicitante.filter(c => c.cotaTipoId === this.item.cotaTipoId)

            return cotasDoTipo.map(cota => {

                const isValor = this.item.cotaTipoId === this.enums.tipoCota.VALOR

                const cotaNumero = isValor
                    ? parseFloat(String(cota.cotaValor).replace(/\./g, '').replace(',', '.')) || 0
                    : Number(cota.cotaUnidade) || 0

                const limite = percentual !== null ? Math.floor(cotaNumero * percentual / 100) : '-'

                return {
                    periodo: `${cota.periodo.start} - ${cota.periodo.end}`,
                    cota: isValor
                        ? `R$ ${cota.cotaValor}`
                        : cota.cotaUnidade,
                    percentual: percentual !== null ? `${percentual}%` : '-',
                    limiteApp: isValor && percentual !== null
                        ? `R$ ${Number(limite).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : limite,
                }
            })
        },
    },
    data: () => ({
        item: null,
        fields: [
            { key: 'periodo', label: 'Período' },
            { key: 'cota', label: 'Cota total' },
            { key: 'percentual', label: 'Percentual APP' },
            { key: 'limiteApp', label: 'Limite APP Cidadão' },
        ],
        enums: { tipoCota },
    }),
    methods: {
        open(item) {

            this.item = item
            this.$refs.RkmModal.show()
        },
    },
    props: {
        cotas: { type: Array, required: true },
        prestadores: { type: Array, required: true },
    },
}
</script>
